import useSWR, { type Fetcher } from 'swr';

import { ticketsProblemTypesList } from '~/data/generated/endpoints/tickets/tickets';
import { parseApiResponse } from '~/data/parseApiResponse';
import { type TicketProblemTypeOption, ticketProblemTypesSchema } from '~/data/schemas/ticket';

export interface ProblemTypeOption {
  name: string;
}

const ticketProblemTypesFetcher: Fetcher<
  TicketProblemTypeOption[],
  readonly [key: 'ticketProblemTypes']
> = async () => {
  const { data } = await ticketsProblemTypesList();
  return parseApiResponse(ticketProblemTypesSchema, data, 'TicketProblemType');
};

export const useTicketProblemTypes = () => {
  const { data: problemTypes, isLoading } = useSWR(
    ['ticketProblemTypes'],
    ticketProblemTypesFetcher,
    {},
  );

  return { problemTypes, isLoading };
};
